import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Tabs,
  Tab,
} from 'react-bootstrap';

import Footer from 'Components/Footer';
import { useDispatch } from 'react-redux';
import { useHistory , Link } from 'react-router-dom';
import TabsIcon from 'MiddleSystems/Components/layout/TabsIcon';
import Back from 'assets/icon/back.png';
import Service from 'assets/icon/management.png';
import DamageReport from 'MiddleSystems/Staff/Components/DamageReport';
import Log from 'MiddleSystems/Staff/Components/Log';
import EditData from 'MiddleSystems/Staff/Components/EditData';
import Dashboard from 'MiddleSystems/Staff/Components/Dashboard';
import { useParams } from 'react-router-dom';

import { FindEmployee} from 'actions/employee/index';

export default function Index() {
  const dispatch = useDispatch();
  let { id } = useParams();


  const history = useHistory();
  const [key, setKey] = useState('data');
  
  const [Employee, setEmployee] = useState(null);
  const [isLoading, setLoading] = useState(true);
  
  function close() {
    history.push(`/staff`);
  }

  const GetEmployee = () => {
    setLoading(true)
    const params = {
      isDashboard: true
    }
    dispatch(FindEmployee({id, params})).then( response => {
      setEmployee(response.data.data)
      setLoading(false)
    }).catch(e => {
      setLoading(false)
      console.log(e)
    })
  }

  useEffect(() => {
    GetEmployee();
  }, [id]);
  return (
    <>
      
      <Container fluid className="package-container  Stocks Service Staff bg-mrk">
        <div className="package">
          <div className="modal-dialog modal-xl" role="document">
            <div id="overlay" className={ isLoading ? 'd-block' : ''}>
                <div className='spinner-field-fixed'>
                  <div className='spinner-border' role='status'></div>
                </div>
              </div>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  <img className="logo pr-2" src={Service} />
                  <b><Link to="/staff" className='link-pagination'>ครอบครัว(MRKfam) </Link> &gt; แก้ไขครอบครัว(MRKfam)</b>
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={close}
                >
                  <span aria-hidden="true">X</span>
                </button>
              </div>
              <div className="modal-header-mobile">
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={close}
                >
                  <img src={Back} />
                </button>
                <h5 className="modal-title" id="exampleModalLabel">
                  <img className="logo pr-2" src={Service} />
                  <b><Link to="/staff" className='link-pagination'>พนักงาน &gt; รายชื่อพนักงาน</Link> &gt; แก้ไขพนักงาน</b>
                </h5>
              </div>
              <div className="modal-body">
                <Row className="g-0 tabsicon justify-content-center ">
                  <TabsIcon />
                </Row>
                <Row className="g-0 justify-content-center Staff-tabs">
                  <Col className="  set-col-tabs ">
                    <div className="box-typecar ">
                      <Tabs
                        id="controlled-tab-example"
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        className="mb-4"
                      >
                        <Tab eventKey="data" title="ข้อมูลส่วนตัว">
                          <Row className="Data-height justify-content-center">
                            <EditData />
                          </Row>
                        </Tab>

                        <Tab eventKey="damagereport" title="บันทึกความเสียหาย">
                          <DamageReport />
                        </Tab>

                        <Tab eventKey="Log" title="Log">
                          <Log />
                        </Tab>

                        <Tab eventKey="Dashboard" title="Dashboard">
                          <Dashboard />
                        </Tab>
                      </Tabs>
                    </div>
                  </Col>
                </Row>
                <Row className="g-0 mt-3 mb-3"></Row>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
}
